export const separator = ':'

export const licenseSeparator = '-'

// eslint-disable-next-line no-secrets/no-secrets
export const publicKeyPem = `MHYwEAYHKoZIzj0CAQYFK4EEACIDYgAEJDKWHzXT9YZw7WDJy4wr/VMXBf+/afNB
  ppCLv1zZFVUQEmDRPhGC5nKux3WQcrtfl18iNFfISjcqN5vplR/kcAvIJd07tacn
  y1l39NGbMLIoPVzPY6GXTNzQpxRbGn99`
